'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _rx = require('rx');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LocalStreamingLog = function () {
    function LocalStreamingLog() {
        _classCallCheck(this, LocalStreamingLog);

        this._subject = new _rx.Subject();
        this._topics = {};
    }

    _createClass(LocalStreamingLog, [{
        key: 'publish',
        // Map[String, Observable[String]]
        value: function publish(topic, message) {
            //console.log(`topic: ${topic}; message: ${message}`);
            this._subject.onNext({ topic: topic, message: message });
        }
    }, {
        key: 'getTopic',
        value: function getTopic(topic) {
            var ret = this._topics[topic];
            if (!ret) {
                ret = this._subject.filter(function (ev) {
                    return ev.topic == topic;
                }).map(function (ev) {
                    return ev.message;
                });
                this._topics[topic] = ret;
            }
            return ret;
        }
    }]);

    return LocalStreamingLog;
}();

exports.default = LocalStreamingLog;


//////////////////
// WEBPACK FOOTER
// ../~/event-bus-rx/lib/LocalStreamingLog.js
// module id = 707
// module chunks = 0